import { render } from "./ShiftPermissionCommentCountCell.vue?vue&type=template&id=04fa4e11&scoped=true"
import script from "./ShiftPermissionCommentCountCell.vue?vue&type=script&lang=js"
export * from "./ShiftPermissionCommentCountCell.vue?vue&type=script&lang=js"

import "./ShiftPermissionCommentCountCell.vue?vue&type=style&index=0&id=04fa4e11&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fa4e11"]])

export default __exports__